export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./attach-contact.vue?vue&type=template&id=801bdb90&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/attach-contact.vue?vue&type=template&id=801bdb90&
// module id = 1392
// module chunks = 0